import { forwardRef, memo } from 'react';

import { AlertProps } from '@material-ui/lab/Alert';

import { AlertStyled } from './Alert.styles';

export const Alert = memo(
  forwardRef((props: AlertProps, ref) => {
    return (
      <AlertStyled
        onClose={() => null}
        ref={ref}
        elevation={6}
        variant="filled"
        icon={false}
        {...props}
        data-testid="alert"
      >
        {props.children}
      </AlertStyled>
    );
  }),
);
